module.exports = __webpack_public_path__ + "img/OBCINA RADOVLJICA.11dc70c3.png";